import React, { useContext, useEffect, useRef, useState } from 'react'
import 'stylesheets/TimerAppStyles/TodoFilter.css'
import { TodoContext } from 'contexts/TimerAppContexts/TodoContext';

const TodoFilter = () => {
    const [showOptionsFilter, setShowOptionsFilter] = useState(false);
    const filterContainer = useRef()

    const selectLabel = document.querySelector("#select-label")

    const { setFilterValue } = useContext(TodoContext);

    const handleShowOptions = (e) => {
        e.preventDefault()
        setShowOptionsFilter(!showOptionsFilter)
    }

    const setSelectTitle = (e) => {
        const labelElement = document.querySelector(`label[for=${e.target.id}]`).innerText;
        selectLabel.innerText = labelElement
        setFilterValue(e.target.value)
        setShowOptionsFilter(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterContainer.current && !filterContainer.current.contains(event.target)) {
                setShowOptionsFilter(false)
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    return (
        <div className='filter-main-container'>
            <div className='todo-filter-container' ref={filterContainer}>
                <label htmlFor="button" className='filter-h1'>Filtrar por</label>
                <button className='button' id='button' onClick={handleShowOptions}>
                    <span id="select-label">No Filter</span>
                    <div className='arrow'></div>
                </button>
                <div className={`todo-options-container ${showOptionsFilter ? '' : 'hidden'}`}>
                    <label className='select-item' htmlFor="select-no">No Filter</label>
                    <input onClick={setSelectTitle} className='option' id='select-no' type='radio' name='filter' value="no" />

                    <label className='select-item' htmlFor="select-gym">Gym</label>
                    <input onClick={setSelectTitle} className='option' id='select-gym' type='radio' name='filter' value="gym" />

                    <label className='select-item' htmlFor="select-home">Home</label>
                    <input onClick={setSelectTitle} className='option' id='select-home' type='radio' name='filter' value="home" />

                    <label className='select-item' htmlFor="select-programming">Programming</label>
                    <input onClick={setSelectTitle} className='option' id='select-programming' type='radio' name='filter' value="programming" />
                    
                    <label className='select-item' htmlFor="select-school">School</label>
                    <input onClick={setSelectTitle} className='option' id='select-school' type='radio' name='filter' value="school" />
                
                    <label className='select-item' htmlFor="select-work">Work</label>
                    <input onClick={setSelectTitle} className='option' id='select-work' type='radio' name='filter' value="work" />

                    <label className='select-item' htmlFor="select-chores">Chores</label>
                    <input onClick={setSelectTitle} className='option' id='select-chores' type='radio' name='filter' value="chores" />
                    
                    <label className='select-item' htmlFor="select-others">Others</label>
                    <input onClick={setSelectTitle} className='option' id='select-others' type='radio' name='filter' value="others" />
                </div>
            </div>
        </div>
    )
}

export default TodoFilter